module.exports = __webpack_public_path__ + "images/012459628a9621b6d582b150ebaa1530.png";